/* eslint-disable one-var */
/* eslint-disable space-before-function-paren */

import {translations} from "../utils/translations";

export default {
    appLoaded(state) {
        return state.appLoaded;
    },
    cpr(state) {
        return state.cpr;
    },
    devEnv(state) {
        return state.devEnv;
    },
    dmValid(state) {
        return state.dmValid;
    },
    maValid(state) {
        return state.maValid;
    },
    childUrl(state) {
        return state.childUrl;
    },
    educations(state) {
        return state.educations;
    },
    error(state) {
        return state.error;
    },
    isTrustee(state) {
        return state.isTrustee;
    },
    institutes(state) {
        return state.institutes;
    },
    countries(state) {
        return state.countries;
    },
    maCountries(state) {
        return state.maCountries;
    },
    funds(state) {
        return state.funds;
    },
    member(state) {
        return state.member;
    },
    educationLevels(state) {
        state.educationLevels;
    },
    umbracoId(state) {
        return state.umbracoId;
    },
    text(state) {
        return state.text;
    },
    newsLetterText(state) {
        return state.newsLetterText;
    },
    newsLetterTextExtra(state) {
        return state.newsLetterTextExtra;
    },
    consentTextObject(state) {
        return state.consentTextObject;
    },
    steps(state) {
        return state.steps;
    },
    currentComponent(state) {
        return state.currentComponent;
    },
    formType(state) {
        return state.formType;
    },
    selectChoices(state) {
        return state.selectChoices;
    },
    serverResponse(state) {
        return state.serverResponse;
    },
    loadingResponse(state) {
        return state.loadingResponse;
    },
    formSendNoErrors(state) {
        if (state.serverResponse) {
            return state.serverResponse.isSuccess;
        }
        return false;
    },
    english(state) {
        return state.english;
    },
    campaignCode(state) {
        return state.campaignCode;
    },
    campaignCodeList(state) {
        return state.campaignCodeList;
    },
    akasse(state) {
        return state.akasse;
    },
    isCallCenter(state) {
        return state.isCallCenter;
    },
    fullFormFormat(state) {
        return state.fullFormFormat;
    },
    subType(state) {
        return state.subType;
    },
    subscriptions(state) {
        return state.subscriptions;
    },
    employerLoading(state) {
        return state.employerLoading;
    },
    employers(state) {
        return state.employers;
    },
    currentComponentIndex(state) {
        if (state.steps.length > 0) {
            return state.steps.indexOf(state.currentComponent);
        }
        return null;
    },
    halfMember(state) {
        return state.halfMember;
    },
    maternity(state) {
        return state.maternity;
    },
    jobs(state) {
        return state.jobs;
    },
    jobPositions(state) {
        return state.jobPositions;
    },
    jobTypes(state) {
        return state.jobTypes;
    },
    pensionType(state) {
        return state.pensionType;
    },
    socialMoney(state) {
        return state.socialMoney;
    },
    maNotAllowedWarning(state) {
        return state.maNotAllowedWarning;
    },
    studentsUrl(state) {
        return state.studentsUrl;
    },
    educationLoaded(state) {
        return state.educationLoaded;
    },
    educationError(state) {
        return state.educationError;
    },
    workLoaded(state) {
        return state.workLoaded;
    },
    workError(state) {
        return state.workError;
    },
    maLoaded(state) {
        return state.maLoaded;
    },
    maError(state) {
        return state.maError;
    },
    presents(state) {
        return state.presents;
    },
    campaignConditions(state) {
        return state.campaignConditions;
    },
    selectedGift(state) {
        return state.selectedGift;
    },
    klMember(state) {
        return state.klMember;
    },
    glMember(state) {
        return state.glMember;
    },
    helpBenefits(state) {
        return state.member.helpBenefits;
    },
    workingAreas(state) {
        return state.workingAreas;
    },
    currentTranslation(state) {
        return state.english ? translations.en : translations.da;
    },
    fuseSearch(state) {
        return state.fuseSearch;
    },
    workFormState(state){
        return state.workFormState;
    }
};